// extracted by mini-css-extract-plugin
module.exports = {"container":"MaintenanceLayout_container__1MJYa","main":"MaintenanceLayout_main__30RRw","header":"MaintenanceLayout_header__1vtxm","rotate":"MaintenanceLayout_rotate__3FJiq"};